module.exports = __webpack_public_path__ + "static/media/image-video-4.b74f4b43.png";